const LINK_PANEL_MODAL_LINK_INPUT = "linkPanelInput";
const LINK_SETTINGS_CHECKBOX_NEW_TAB = "linkPanelBlankCheckbox";
const LINK_SETTINGS_CHECKBOX_NOREFERRER = "linkPanelNoreferrerCheckbox";
const LINK_SETTINGS_CHECKBOX_NOFOLLOW = "linkPanelRelCheckbox";
const LINK_SETTINGS_CHECKBOX_SPONSORED = "linkPanelSponsoredCheckbox";
export {
  LINK_PANEL_MODAL_LINK_INPUT,
  LINK_SETTINGS_CHECKBOX_NEW_TAB,
  LINK_SETTINGS_CHECKBOX_NOFOLLOW,
  LINK_SETTINGS_CHECKBOX_NOREFERRER,
  LINK_SETTINGS_CHECKBOX_SPONSORED
};
//# sourceMappingURL=data-hooks.js.map
